module.exports = __webpack_public_path__ + "img/bb2.2db6eb77.png";